'use client';

import { JSX } from 'react';
import { FeatureFlag as FeatureFlagType } from '@config/featureFlags/featureFlags';
import { useClientHasRendered } from '@domain/session/useClientHasRendered';
import { useFeatureFlags } from '@hooks/useFeatureFlags';

interface IProps {
  oldComponent?: JSX.Element;
  newComponent?: JSX.Element;
  featureFlag: FeatureFlagType;
}

export const FeatureFlag = ({
  featureFlag,
  oldComponent = <></>,
  newComponent = <></>,
}: IProps) => {
  const result = useFeatureFlags([featureFlag]);
  // We stick to running feature flagged content on the client only as static pages in Next don't
  // have access to query strings during initial render and this can cause hydration mismatches.
  const clientHasRendered = useClientHasRendered();

  return clientHasRendered && result[featureFlag] ? newComponent : oldComponent;
};
